import * as tslib_1 from "tslib";
import { Component } from "vue-property-decorator";
import { BaseControl } from "../../../src/renderer/controls";
import Axios from "axios";
import { Rate, Input } from "@h3/antd-vue";
import axios from "axios";
let TaskMarker = class TaskMarker extends BaseControl {
    // this.ctrl 组件的控制器. 组件的value 通过 this.ctrl获取
    get val() {
        console.log(this.ctrl.value && JSON.parse(this.ctrl.value));
        return (this.ctrl.value && JSON.parse(this.ctrl.value)) || [];
    }
    //
    todoLight(item, status) {
        if (item.isAllowableMark === false)
            return;
        if (!item.isEdit) {
            let url = 'saveExpatStatus';
            if (status === '1') {
                url = 'saveExpatStatus';
            }
            else if (status === '0') {
                url = 'removeExpatStatus';
            }
            Axios.post(`/api/expact/${url}`, {
                bizobjectid: item.bizobjectid,
                schemacode: item.schemacode,
                bizpropertycode: item.code,
                status: item.status,
            }).then((res) => {
                if (res.errcode === 0) {
                    this.$confirm({
                        title: "Success",
                        content: res.errmsg,
                        icon: 'check-circle',
                        type: "success",
                        width: "740px",
                        okText: "CLOSE",
                        cancelButtonProps: { style: { display: "none" } },
                    });
                    const setValue = this.val.map((element) => {
                        if (element.code === item.code) {
                            element.highlightStatus = status;
                        }
                        return element;
                    });
                    this.$set(this.ctrl, 'value', JSON.stringify(setValue));
                }
            });
        }
        else {
            this.$confirm({
                title: "Error",
                content: "Save this Application First!",
                icon: 'close-circle',
                type: "Error",
                width: "740px",
                okText: "CLOSE",
                cancelButtonProps: { style: { display: "none" } },
            });
        }
    }
    // handleClickDelete(item:any){
    //   Axios.post("/api/expact/removeExpatStatus", {
    //       bizobjectid: item.bizobjectid,
    //       schemacode: item.schemacode,
    //       bizpropertycode: item.code,
    //       status: item.status,
    //     }).then((res: any) => {
    //       if (res.errcode === 0) {
    //         this.$confirm({
    //           title: "Success",
    //           content: res.errmsg,
    //           icon:'check-circle',
    //           type: "success",
    //           width: "740px",
    //           okText: "CLOSE",
    //           cancelButtonProps: { style: { display: "none" } },
    //         } as any);
    //         const setValue:any = this.val.filter((element:any) => element.code !== item.code)
    //         this.$set(this.ctrl,'value',JSON.stringify(setValue))
    //       }
    //     });
    // }
    toSendEmail(item) {
        if (item.allowSendEmailType === 'manual') {
            if (item.schemacode === 'assignment') {
                axios.get(`/api/expatEmail/sendFirstHrEmail?id=${item.bizobjectid}`).then((res) => {
                    if (res.errcode === 0) {
                        this.$confirm({
                            title: "Success",
                            content: res.errmsg,
                            icon: 'check-circle',
                            type: "success",
                            width: "740px",
                            okText: "CLOSE",
                            cancelButtonProps: { style: { display: "none" } },
                        });
                        const setValue = this.val.map((element) => {
                            if (element.code === item.code) {
                                element.emailSendStatus = '1';
                            }
                            return element;
                        });
                        this.$set(this.ctrl, 'value', JSON.stringify(setValue));
                    }
                    else {
                        this.$confirm({
                            title: "Error",
                            content: res.errmsg,
                            icon: 'close-circle',
                            type: "Error",
                            width: "740px",
                            okText: "CLOSE",
                            cancelButtonProps: { style: { display: "none" } },
                        });
                    }
                });
            }
            else if (item.schemacode === 'housing') {
                axios.get(`/api/expatEmail/sendFirstHousingEmail?id=${item.bizobjectid}`).then((res) => {
                    if (res.errcode === 0) {
                        this.$confirm({
                            title: "Success",
                            content: res.errmsg,
                            icon: 'check-circle',
                            type: "success",
                            width: "740px",
                            okText: "CLOSE",
                            cancelButtonProps: { style: { display: "none" } },
                        });
                        const setValue = this.val.map((element) => {
                            if (element.code === item.code) {
                                element.emailSendStatus = '1';
                            }
                            return element;
                        });
                        this.$set(this.ctrl, 'value', JSON.stringify(setValue));
                    }
                    else {
                        this.$confirm({
                            title: "Error",
                            content: res.errmsg,
                            icon: 'close-circle',
                            type: "Error",
                            width: "740px",
                            okText: "CLOSE",
                            cancelButtonProps: { style: { display: "none" } },
                        });
                    }
                });
            }
            // this.$confirm({
            //   title: "Error",
            //   content: "Fill in this Assignments Location First",
            //   icon:'close-circle',
            //   type: "Error",
            //   width: "740px",
            //   okText: "CLOSE",
            //   cancelButtonProps: { style: { display: "none" } },
            // } as any);
        }
    }
    tipsEmailHasBeenSend() {
        this.$confirm({
            title: "Error",
            content: "This Email has been send.",
            icon: 'close-circle',
            type: "Error",
            width: "740px",
            okText: "CLOSE",
            cancelButtonProps: { style: { display: "none" } },
        });
    }
};
TaskMarker = tslib_1.__decorate([
    Component({
        name: "TaskMarker",
        components: {
            ARate: Rate,
            AInput: Input,
        },
    })
], TaskMarker);
export default TaskMarker;
